var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"ma-0 pa-0",attrs:{"value":_vm.value,"required":"","label":_vm.label,"dense":"","outlined":"","readonly":""}})}
var staticRenderFns = []

export { render, staticRenderFns }